import {Routes} from '@angular/router';

import {redirectLoggedInToTest, requireEmailVerified, requireEmailVerifiedOrPublicTest} from './guard-helpers';

export const assessmentRoutes: Routes = [
        {
                path: 'test',
                canActivate: [requireEmailVerifiedOrPublicTest],
                loadComponent: () => import('../pages/test/test.component').then((c) => c.TestComponent)
        },
        {
                path: 'test-bdsm',
                canActivate: [redirectLoggedInToTest],
                loadComponent: () => import('../pages/test_anon/test_anon.component').then((c) => c.Test_AnonComponent)
        },
        {
                path: 'before-test',
                canActivate: [requireEmailVerified],
                loadComponent: () => import('../pages/before-test/before-test-page.component').then((c) => c.BeforeTestPageComponent)
        },
        {
                path: 'results-test',
                canActivate: [requireEmailVerified],
                children: [
                        {
                                path: '',
                                loadComponent: () => import('../pages/results/results-page.component').then((c) => c.ResultsPageComponent)
                        },
                        {
                                path: 'more-info',
                                loadComponent: () => import('../pages/results/more-info/more-info-page.component').then((c) => c.MoreInfoPageComponent)
                        },
                        {
                                path: 'share',
                                loadComponent: () => import('../pages/share/share-page.component').then((c) => c.SharePageComponent)
                        }
                ]
        },
        {
                path: 'questionnaire',
                canActivate: [requireEmailVerified],
                loadComponent: () => import('../pages/questionnaire/questionnaire-page.component').then((c) => c.QuestionnairePageComponent)
        }
];
